import React, { useEffect, useState } from "react";
import axios from "axios";
import { Building2, Users } from "lucide-react";
import { orgNameWarning } from "../../utils/orgName";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const B2BCreateSection = ({ formData, setFormData, userEmail }) => {
  const [count, setCount] = useState(null);
  const [cfg, setCfg] = useState(null);
  const enabled = !!formData.is_b2b;

  useEffect(() => {
    if (enabled && !cfg) axios.get(`${API}/b2b/config`).then(r => setCfg(r.data)).catch(() => {});
  }, [enabled, cfg]);

  useEffect(() => {
    if (!enabled) return;
    const params = new URLSearchParams({ radius: 15 });
    if (formData.latitude && formData.longitude) {
      params.set("latitude", formData.latitude);
      params.set("longitude", formData.longitude);
    }
    axios.get(`${API}/b2b/executors-count?${params}`).then(r => setCount(r.data)).catch(() => setCount(null));
  }, [enabled, formData.latitude, formData.longitude]);

  const set = (k, v) => setFormData(prev => ({ ...prev, [k]: v }));

  return (
    <div className="rounded-lg p-3 space-y-3" style={{ background: enabled ? "#F0F9FF" : "#fff", border: enabled ? "1px solid #7DD3FC" : "1px solid var(--rv-border)" }} data-testid="b2b-create-section">
      <label className="flex items-start gap-2 cursor-pointer">
        <input type="checkbox" data-testid="b2b-toggle" checked={enabled}
          onChange={e => setFormData(prev => ({ ...prev, is_b2b: e.target.checked, b2b_docs_email: prev.b2b_docs_email || userEmail || "" }))}
          className="mt-0.5" style={{ accentColor: "#0369A1" }} />
        <span className="text-sm" style={{ color: "var(--rv-text-primary)" }}>
          <span className="font-medium flex items-center gap-1.5"><Building2 size={15} /> Я представляю организацию (нужны закрывающие документы)</span>
          <span className="block text-xs mt-0.5" style={{ color: "var(--rv-text-secondary)" }}>
            Онлайн-оплата не требуется: организация платит исполнителю напрямую, платформа формирует договор и акт. Откликаться смогут только самозанятые, ИП и ООО.
          </span>
        </span>
      </label>

      {enabled && (
        <div className="space-y-3">
          {cfg && (
            <div data-testid="b2b-commission-plaque" className="text-xs rounded-md px-3 py-2" style={{ background: "#ECFDF5", border: "1px solid #6EE7B7", color: "#065F46" }}>
              {cfg.commission_enabled
                ? `Комиссия платформы для организаций — ${cfg.commission_percent} %.`
                : "Комиссия платформы для организаций на старте — 0 %. Оплата исполнителю напрямую, без наценки платформы."}
            </div>
          )}
          <div className="grid sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium mb-1" style={{ color: "var(--rv-text-secondary)" }}>ИНН организации (10 или 12 цифр)</label>
              <input data-testid="b2b-inn-input" value={formData.b2b_inn || ""} inputMode="numeric" required
                onChange={e => set("b2b_inn", e.target.value.replace(/\D/g, "").slice(0, 12))}
                className="w-full px-3 py-2 rounded-lg text-sm" style={{ border: "1px solid var(--rv-border)" }} />
            </div>
            <div>
              <label className="block text-xs font-medium mb-1" style={{ color: "var(--rv-text-secondary)" }}>Название организации</label>
              <input data-testid="b2b-org-name-input" value={formData.b2b_org_name || ""} required maxLength={200}
                onChange={e => set("b2b_org_name", e.target.value)}
                className="w-full px-3 py-2 rounded-lg text-sm" style={{ border: "1px solid var(--rv-border)" }} />
              {orgNameWarning(formData.b2b_org_name) && (
                <p data-testid="b2b-org-name-warning" className="text-xs mt-1 px-2 py-1 rounded" style={{ background: "#FEF9C3", color: "#854D0E", border: "1px solid #FDE047" }}>
                  {orgNameWarning(formData.b2b_org_name)} Укажите полное название, например «ООО Ромашка».
                </p>
              )}
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium mb-1" style={{ color: "var(--rv-text-secondary)" }}>Email для документов</label>
            <input data-testid="b2b-docs-email-input" type="email" value={formData.b2b_docs_email || ""} required
              onChange={e => set("b2b_docs_email", e.target.value)}
              className="w-full px-3 py-2 rounded-lg text-sm" style={{ border: "1px solid var(--rv-border)" }} />
          </div>
          <div className="text-xs p-2.5 rounded-lg flex items-start gap-2" style={{ background: "#fff", border: "1px solid #7DD3FC", color: "#0C4A6E" }} data-testid="b2b-executors-count">
            <Users size={14} className="mt-0.5 flex-shrink-0" />
            <span>
              {count === null ? "Считаем исполнителей с бизнес-статусом..." :
                count.nearby !== null && count.nearby !== undefined
                  ? `Исполнителей с бизнес-статусом в радиусе 15 км: ${count.nearby} (всего на платформе: ${count.total}).`
                  : `Исполнителей с бизнес-статусом на платформе: ${count.total}.`}
              {" "}Реквизиты организации не публикуются и видны только выбранному исполнителю.
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
